import React from "react";

import Grid from "@material-ui/core/Grid";

import { CollapseHeader, FormCollapse } from "components/Form";
import { withNamespace } from "components/Form/FormikControls";
import { BusinessField } from "components/Form/Fields/BusinessField";

import { FinanceSubModalSection } from "constants/settings";

import { SectionToggleState, useSectionHelper } from "hooks";

interface ClearingSaleSectionProps {
  sectionHelper: SectionToggleState;
  namespace: string;
}

export const ClearingSaleSettings = ({
  sectionHelper,
  namespace: ns,
}: ClearingSaleSectionProps) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.CLEARING_SALE,
  );

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={<CollapseHeader title="Clearing Sale" />}
      dataTour="clearing-sale"
    >
      <Grid item xs={12} md={6}>
        <BusinessField
          label="Default Cash Buyer"
          name={withNamespace(ns, "cashBuyerBusinessId")}
          allowAddNew={false}
        />
      </Grid>
    </FormCollapse>
  );
};
